<!-- Grafica -->
<ng-container *ngIf="!cargandoGraph && semanaMesSeleccionado.length > 0">
  <ngx-charts-bar-vertical
    [view]="viewGraph"
    [scheme]="colorScheme"
    [results]="semanaMesSeleccionado"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [gradient]="gradient"
    [legend]="showLegend"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [showDataLabel]="showDataLabel"
    [tooltipDisabled]="false"
    [roundEdges]="roundEdges"
    [trimXAxisTicks]="trimXAxisTicks"
    [dataLabelFormatting]="formatDataLabel"
  >
  </ngx-charts-bar-vertical>

  <hr class="base-graph" [ngStyle]="{ 'top.px': viewGraph[1] + 73 }" />
</ng-container>

<!-- Sin informacion -->
<div
  *ngIf="!cargandoGraph && semanaMesSeleccionado.length === 0"
  class="no-info"
>
  <div class="center">
    <ion-label color="white">{{ sinInformacion }}</ion-label>
  </div>
</div>

<!-- skeleton -->
<div *ngIf="cargandoGraph" class="skeleton-graph">
  <ion-skeleton-text
    animated
    class="skeleton"
    style="height: 20%"
  ></ion-skeleton-text>
  <ion-skeleton-text
    animated
    class="skeleton"
    style="height: 40%"
  ></ion-skeleton-text>
  <ion-skeleton-text
    animated
    class="skeleton"
    style="height: 70%"
  ></ion-skeleton-text>
  <ion-skeleton-text
    animated
    class="skeleton"
    style="height: 90%"
  ></ion-skeleton-text>
</div>
